import { ReportType } from '@/api/generatedApi';
import { Tooltip } from '@mui/material';
import {
  ContentCopy as DuplicationIcon,
  TrendingDown as SimplificationIcon,
  Tune as CustomIcon,
} from '@mui/icons-material';
import { REPORT_TITLES } from './consts';
import { ReportPageObjectModel } from '@/poms/reportPageObjectModel';

const reportTypeIconMap = {
  [ReportType.DUPLICATION]: DuplicationIcon,
  [ReportType.SIMPLIFICATION]: SimplificationIcon,
  [ReportType.CUSTOM]: CustomIcon,
};

export const ReportTypeIcon = ({ reportType }: { reportType: ReportType }) => {
  const Icon = reportTypeIconMap[reportType];

  return (
    <Tooltip title={REPORT_TITLES[reportType]}>
      <Icon data-testid={ReportPageObjectModel.ReportTypeIcon} sx={{ fontSize: '24px', display: 'block' }} />
    </Tooltip>
  );
};
